import { AuthResponse } from '@adminPortal/_common/_interfaces/IAuthResponse';
import { Authorization } from '@adminPortal/_common/_services/authorization/authorization';
import { UserService } from '@adminPortal/_common/_services/user/user.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService implements Authorization {
  private readonly authorized$: BehaviorSubject<boolean>;

  constructor(private userState: UserService) {
    this.authorized$ = new BehaviorSubject(this.hasValidToken());
  }

  public getEmail(): string | null {
    return this.userState.getAuthEmail();
  }

  public setEmail(email: string): void {
    this.userState.setAuthEmail(email);
  }

  public getToken(): string | null {
    return this.userState.getAuthToken();
  }

  public setToken(token: string): void {
    this.userState.setAuthToken(token);
    this.authorized$.next(true);
  }

  public setTokens(response: AuthResponse): void {
    this.userState.setAuthTokens(response);
    this.authorized$.next(true);
  }

  public getRefreshToken(): string | null {
    return this.userState.getRefreshToken();
  }

  public isTokenExpired(): boolean {
    const expireAt = this.userState.getTokenExpireAt();
    return expireAt ? Date.now() / 1000 > expireAt : true;
  }

  public isRefreshTokenValid(): boolean {
    const expireAt = this.userState.getRefreshTokenExpireAt();
    return expireAt ? Date.now() / 1000 < expireAt : false;
  }

  private hasValidToken(): boolean {
    return !this.isTokenExpired() || this.isRefreshTokenValid();
  }

  public invalidateToken(): void {
    this.userState.clearAuthTokens();
    this.authorized$.next(false);
  }

  public listenToAuthorized(): Observable<boolean> {
    return this.authorized$;
  }
}
